import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Menu,
  Select,
  MenuItem,
  ThemeProvider,
  createTheme,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setSelectedLoanNumber } from "../../services/redux/slices/dashboardDataSlice";
import { RootState } from "../../services/redux/store";
import { useSelector } from "react-redux";
import { SelectChangeEvent } from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { setSelectedIndex } from "../../services/redux/slices/tabsSlice";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { clearPartPaymentType } from "../../services/redux/slices/documentFormSlice";
const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          "&:before, &:after": {
            display: "none",
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "#fefefe", // Set the background color of the dropdown
          width: "180px",
          "& .MuiMenuItem-root": {
            // Target the menu items within the dropdown
            fontSize: "12px", // Set the font size of the menu items
          },
        },
      },
    },
  },
});

interface AccountSelectorProps {
  buttonText: string;
  isActive: string;
  labelText: string;
  borderWidth?: string;
  backgroundColor?: string;
  marginTop?: string;
}
interface DashboardData {
  loanAccountNumber?: string;
  lanNumber?: string;
  statusOfLoan: string;
  loanAmount: number;
  outstandingPrincipal: number;
  emiAmount: number;
  nextEmiDate: string;
  overdueAmount: number;
  description: string;
  firstDisbDate: string;
  maturityDate: string;
  loanTypeId: number;
  isExistDisbursementAllowdLoan: boolean;
}

const AccountSelectorDropDown: React.FC<AccountSelectorProps> = ({
  buttonText,
  isActive,
  labelText,
  borderWidth,
  backgroundColor,
  marginTop,
}) => {
  const dispatch = useDispatch();
  // Selecting loan number from Redux state
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber
  );
  const dashboardDataSet: DashboardData[] = useSelector(
    (state: RootState) => state?.dashboardData?.sanctionedDisbursedData
  );
  const selectCreateLoan: any = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );

  // Using local state for selected loan number
  const [selectedLanNumber, setSelectedLanNumber] = useState<string>(
    selectedLoanNumber ?? ""
  );
  const selectedIndex = useSelector(
    (state: RootState) => state.tabs.selectedIndex
  );
  // Selecting loan account number options from Redux state (if needed)
  const loanAccountNumberOptions = useSelector(
    (state: RootState) => state?.option?.loanAccountNumberOptions
  );
  const productName = useSelector((state: RootState) => state.tabs.productName);
  let buttonValue = useSelector(
    (state: RootState) => state.disbursementButtonSlice.disbursementButtonSlice
  );

  let paymentType: any = useSelector(
    (state: RootState) => state.documentFormSlice.partPaymentType
  );

  const handleOptionChange = (event: any, index: any) => {
    const selectedValue = event.target.innerText?.trim();
    setSelectedLanNumber(selectedValue);
    dispatch(setSelectedLoanNumber(selectedValue));
    dispatch(clearPartPaymentType())
    handleClose();
  };
  useEffect(() => {
    const matchVal: any = dashboardDataSet?.find(
      (data: any) => data?.lanNumber === selectedLoanNumber
    );
    if (matchVal?.isExistDisbursementAllowdLoan === false) {
      if (
        selectedIndex !== 0 &&
        selectedIndex !== 3 &&
        selectedIndex !== 4 &&
        selectedIndex !== 2
      ) {
        dispatch(setSelectedIndex(0));
        dispatch(
          setStatusPopup({
            status: "no access",
            // message: `Disbursement requests are not permitted for this loan.`,
            message:
              "Disbursement requests are currently unavailable for this loan",
          })
        );
      }
    }

    if (selectedIndex == 2) {
      if (["M", "C", "W", "E", "S"].includes(matchVal?.status)) {
        dispatch(setSelectedIndex(0));
        dispatch(
          setStatusPopup({
            status: "no access",
            // message: `Disbursement requests are not permitted for this loan.`,
            message:
              "Payment requests are currently unavailable for this loan",
          })
        );
      }
    }

  }, [selectedLoanNumber, dashboardDataSet, selectedIndex]);
  const [anchorEl, setAnchorEl] = useState(null); // For Menu anchor element

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget); // Open the Menu
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the Menu
  };
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end", // Aligns the button to the right
        marginTop: marginTop || "-42px",
        marginBottom: "5px",
      }}
    >
      <Box>
        <ThemeProvider theme={theme}>
          {/* {selectedLoanNumber == "" || selectedLoanNumber === undefined ? (
            <Button
              variant="outlined"
              disabled // Disable interaction for skeleton
              sx={{
                height: "32px",
                padding: "7px 26px 7px 0px",
                textTransform: "none",
                color: "#a5a3ae", // Lighter color for skeleton effect
                letterSpacing: "0.43px",
                fontSize: "12px",
                fontWeight: "600",
                border: "1px solid rgba(0, 179, 181, 0.5)", // Dimmed border
                borderRadius: "6px",
                borderWidth: borderWidth,
                width: "100%",
                minWidth: "180px",
                backgroundColor: backgroundColor || "#fff",
                "&:hover": {
                  border: "2px solid #dbdade", // Maintain skeleton effect on hover
                },
              }}
            >
              <Box
                sx={{
                  width: "60%", // Placeholder text width
                  height: "12px", // Height of placeholder text
                  backgroundColor: "rgba(0, 0, 0, 0.1)", // Skeleton color
                  borderRadius: "4px",
                  margin: "0 auto", // Center horizontally
                }}
              />
            </Button>
          ) : ( */}
            <>
              <Button
                variant="outlined"
                endIcon={<ArrowDropDownIcon />}
                onClick={handleClick} // Trigger the dropdown when clicked
                disabled={
                  buttonValue === "createNewRequestBtn" ||
                  paymentType == "1" ||
                  paymentType == "2"
                } // Disable button based on condition
                sx={{
                  textTransform: "none",
                  height: "28px",
                  padding: isXsOrSm ? "7px 21px 0px 0px" : " 5px 5px 2px 5px",
                  color: "#00b3b5", // Lighter color for skeleton effect
                  letterSpacing: "0.43px",
                  fontSize: "12px",
                  fontWeight: "600",
                  border: "1px solid #00b3b5", // Dimmed border
                  borderRadius: "4px",
                  width: "100%",
                  minWidth: "180px",
                  borderWidth: borderWidth,
                  backgroundColor: backgroundColor || "#fff",
                  "&:hover": {
                    border: "0px solid #dbdade", // Maintain skeleton effect on hover
                  },
                }}
              >
                {selectedLoanNumber ? `LAN ${selectedLoanNumber}` : `LAN ${selectedLanNumber}`}{" "}
                {/* Default text or selected option */}
              </Button>
              <Menu
                anchorEl={anchorEl} // Set anchor element to button
                open={Boolean(anchorEl)} // Open the menu if anchorEl is set
                onClose={handleClose} // Close the menu when clicking outside
                sx={{
                  mt: 1,
                  maxHeight:"400px",
                }}
              >
                {loanAccountNumberOptions?.map((option: any, index: any) => (
                  <MenuItem
                    key={index}
                    onClick={(event) => handleOptionChange(event, index)} // Handle option selection
                  >
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </>
          {/* )} */}
        </ThemeProvider>
      </Box>
    </Box>
  );
};

export default AccountSelectorDropDown;
